import React, {useEffect, useState} from "react"

function Loading() {
    const dots = ['.  ', ".. ", "...", "..."]
    const [index, setIndex] = useState(0)
    const [message, setMessage] = useState(false)

    useEffect(() => {
        const animation = setInterval(() => {
            setIndex((index) => (index + 1) % 4)
        }, 250)

        const timeoutID = setTimeout(() => {
            setMessage(true)
        }, 5000)
        
        return () => {
            clearInterval(animation)
            clearTimeout(timeoutID)
        }
    }, [])

    return (
        <p id="loading">{message ? "this may take a while" : ''}{dots[index]}</p>
    )
}

export default Loading